<template>
  <div
      :class="['bg-white h-19 overflow-hidden transition-[height_background] lg:hidden', {'h-[100dvh] !bg-grey': opened}]">
    <div class="p-5 flex justify-between items-center">
      <LangRouterLink :to="{name: $routes.HOME}">
        <ResponsiveImage :media="chair.logo" class="h-9"/>
      </LangRouterLink>
      <button class="w-11 h-11 bg-grey rounded-full flex flex-col items-center justify-center gap-[3px]"
              @click.stop="toggle">
        <span :class="['bg-black h-[2px] w-5 transition-[rotate]', {'absolute rotate-45': opened}]"></span>
        <span :class="['bg-black h-[2px] w-5 transition-[rotate]', {'absolute -rotate-45': opened}]"></span>
        <span
            :class="['bg-black h-[2px] w-3 ml-2 transition-[opacity_rotate]', {'rotate-45 opacity-0': opened}]"></span>
      </button>
    </div>
    <div class="h-[calc(100dvh_-_4.75rem)] p-5 pb-8 flex flex-col items-center justify-between overflow-auto">
      <div class="flex flex-col gap-4 w-full items-center">
        <NavigationSection :pages="pages" :section="section" v-for="(section, sectionIndex) in sections"
                           :key="`mobile-section-${sectionIndex}`"/>
        <LangRouterLink :to="{...$route, hash: '#contact'}" class="button w-full">
          {{ $t('contact_us') }}
        </LangRouterLink>
        <div class="mt-3 -mb-1.5 h-[1px] bg-line w-42.5"></div>
  <LangSwitch v-if="!chair?.disable_english_site"/>
      </div>
      <SocialMedia :socials="chair.socials"/>
    </div>
  </div>
</template>

<script lang="ts">
import type {PropType} from "vue";
import {LangRouterLink, ResponsiveImage} from '@/components/helpers'
import {LangSwitch, NavigationSection} from '@/components/navigation/small'
import {SocialMedia} from '@/components/small'

export default {
  name: 'MobileNavigation',
  components: {LangSwitch, LangRouterLink, NavigationSection, ResponsiveImage, SocialMedia},
  props: {
    chair: {
      type: Object as PropType<Chair>,
      required: true
    },
    pages: {
      type: Object as PropType<Record<template, Page>>,
      required: true
    },
    sections: {
      type: Array as PropType<MenuSection[]>,
      required: true
    }
  },
  data() {
    return {
      opened: false as boolean
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    }
  },
  watch: {
    '$route': {
      handler() {
        this.opened = false
      },
      deep: true
    }
  }
}
</script>
